export class PeerData {
  firstName: string;
  lastName: string;
  email: string;
  profile: number;
  status: boolean;
  id: string;

  constructor({ email, profile, firstName = '', lastName = '', status = true, id = '' }: {
    email: string;
    profile: number;
    firstName?: string;
    lastName?: string;
    status?: boolean;
    id?: string;
  }) {
    this.email = email;
    this.profile = profile;
    this.firstName = firstName;
    this.lastName = lastName;
    this.status = status;
    this.id = id;
  }
}
